import cn from "classnames";
import { dateTimeToView } from "helpers/date";
import React, { useEffect, useState } from "react";
import { getParcelStatuses } from "sources/parcel";

export default function ParcelStatusesHistory(props) {
    const [loading, setLoading] = useState(true);
    const [statusesData, setStatusesData] = useState([]);
    useEffect(() => {
        getParcelStatuses(props.id).then((res) => {
            if (res) {
                setStatusesData(res);
            }
            setLoading(false);
        });
    }, []);
    return (
        <div className={cn("parcel__history", { "loading loading--small": loading })}>
            {statusesData.length === 0 && !loading ? (
                <div className="parcel__history-empty">Нет информации об истории отслеживания</div>
            ) : (
                statusesData.map((item, i) => (
                    <div key={i} className="parcel__history-item">
                        <div className="pr-2">
                            <i
                                className={cn("parcel__checkbox", {
                                    "parcel__checkbox--finished": item.isFinal,
                                    "parcel__checkbox--unsuccess": !item.isSuccess,
                                })}
                            />
                        </div>
                        <div>
                            <div>{item.name}</div>
                            <div className="text-muted">{dateTimeToView(item.fixedAt)}</div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
